export const config = {
  /** サーバーサイド（SSR）から API にアクセスする URL（Docker ネットワーク内部） */
  apiUrl: "http://api:3000",
  /** クライアントサイド（ブラウザ）から API にアクセスする URL */
  publicApiUrl: "https://stg-api.b-faq.run",
  /** 公開サイトの URL（canonical URL 等に使用） */
  siteUrl: "https://stg-faq.b-faq.run",
  /** 管理画面の URL（preview バナーのリンク等に使用） */
  adminUrl: "https://stg-admin.b-faq.run",
} as const;
